// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
}

.animate-float {
  animation: float 2s ease-in-out infinite;
}
.b{
  border: 1px solid red;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 4px;
}

.custom-scrollbar {
  scrollbar-width: thin; 
  scrollbar-color: #60A5FA #172554;
}
.bingo_game_page{
  z-index: 30;
}


.tooltip {
  position: relative;
}


.tooltip:hover::after {
  display: block;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,4BAA4B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;;;AAGA;EACE,cAAc;AAChB","sourcesContent":["@keyframes float {\n  0% { transform: translateY(0); }\n  50% { transform: translateY(-20px); }\n  100% { transform: translateY(0); }\n}\n\n.animate-float {\n  animation: float 2s ease-in-out infinite;\n}\n.b{\n  border: 1px solid red;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n}\n\n.custom-scrollbar {\n  scrollbar-width: thin; \n  scrollbar-color: #60A5FA #172554;\n}\n.bingo_game_page{\n  z-index: 30;\n}\n\n\n.tooltip {\n  position: relative;\n}\n\n\n.tooltip:hover::after {\n  display: block;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
